import React from "react";
import { Row, Col, Breadcrumb, Container, Table } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import SEO from "../../components/SEO";

const Refundpolicy = () => {
    const navigate = useNavigate();
    const goBack = () => {
        navigate('/');
    };
    return (
        <>
            <SEO
                title="Refund Policy"
                description="Read Shaadi Material's Refund Policy for subscriptions, digital downloads, billing errors, and refund eligibility."
                canonical="https://shaadimaterial.com/refund-policy"
            />
            <Container className="py-5 policypage">
                <Row className="breadcrumb_part mb-5">
                    <Breadcrumb>
                        <Breadcrumb.Item onClick={goBack}>Home</Breadcrumb.Item>
                        <Breadcrumb.Item active>Refund Policy</Breadcrumb.Item>
                        {/* <Breadcrumb.Item active>Thank You Cards</Breadcrumb.Item> */}
                    </Breadcrumb>
                </Row>
                <Row>
                    <Col md={12}>
                        <h2>Refund Policy</h2>
                        <p><small>Effective Date: August 2026</small></p>

                        <p>
                            This Refund Policy governs all subscriptions and digital content purchases made on Shaadi
                            Material (&quot;we&quot;, &quot;our&quot;, &quot;us&quot;). By purchasing any paid plan or digital asset from our website, you
                            agree to the terms outlined below.
                        </p>
                        <p>
                            Shaadi Material provides digital products and downloadable content, accessed through a coin-based subscription system. Due to the nature of digital delivery, refunds are limited and subject tothe conditions stated in this policy.
                        </p>
                        <h5>1. Non-Refundable Digital Content &amp; Subscriptions</h5>
                        <p><b>Once a digital asset has been downloaded, accessed, or used, the purchase is considered complete. Accordingly:</b></p>
                        <ul>
                            <li>All digital downloads are non-refundable once accessed, and any coins deducted for that download will not be reinstated.</li>
                            <li>Subscription fees are non-refundable after any content usage or any coin redemption.</li>
                            <li>Cancelling a subscription does not entitle the user to a refund for the remaining period or for any unused coin balance.</li>
                        </ul>
                        <p>
                           This applies to all templates, design assets, downloads, coin purchases, and subscription plans offered on Shaadi Material.
                        </p>
                        <h5>2. Limited Refund Eligibility</h5>
                        <p>Refunds may be considered only in the following situations:</p>
                        <p><b>a) Cooling-Off Period (Where Required by Law)</b></p>
                        <p>
                            If applicable consumer protection laws grant you a cooling-off or withdrawal period, you may be
                            eligible for a refund only if no content has been downloaded or accessed, and no coins have been
                            redeemed, during that time. Once access, download, or coin redemption begins, the right to cancel
                            is waived as permitted by law for digital content.
                        </p>
                        <p>
                            Once access or download begins, the right to cancel is waived as permitted by law for digital content.
                        </p>
                        <p><b>b) Unused Purchases</b></p>
                        <p>In rare cases, Shaadi Material may consider a refund for first-time purchases if:</p>
                        <ul>
                            <li>The request is made within a short period after purchase, and</li>
                            <li>No downloads, coin redemption, access, or usage of content has occurred</li>
                        </ul>
                        <p>Such refunds are discretionary and evaluated case-by-case.</p>
                        <p><b>c) Billing Errors or Duplicate Charges</b></p>
                        <p>
                            If you believe you were charged incorrectly (for example, duplicate transactions or payment errors),
                            please contact us immediately. Verified billing errors will be corrected.
                        </p>
                        <h5>3. Situations Where Refunds Are Not Granted</h5>
                        <p>Refunds will not be provided in the following cases:</p>
                        <ul>
                            <li>Content has been downloaded, accessed, or used</li>
                            <li>Any coins have been redeemed or spent</li>
                            <li>Partial use of a subscription</li>
                            <li>Change of mind after purchase</li>
                            <li>Failure to cancel before renewal</li>
                            <li>Exhaustion of coin balance or download limits</li>
                            <li>Early cancellation of an active subscription</li>
                            <li>Early cancellation of an active subscription</li>
                            <li>Incompatibility with third-party software or tools</li>
                        </ul>
                        <p>Once digital content is delivered, the service is considered fulfilled.</p>
                        <h5>Subscription Situations</h5>
                        <div className="table-responsive">
                            <Table bordered className="subscription-policy-table">
                                <thead>
                                <tr>
                                    <th>Situation</th>
                                    <th>Resolution</th>
                                </tr>
                                </thead>

                                <tbody>
                                <tr>
                                    <td>Cancel monthly plan anytime</td>
                                    <td>
                                    No refund; coins remain usable till the end of that billing
                                    month, subscription won't renew
                                    </td>
                                </tr>

                                <tr>
                                    <td>Cancel annual plan mid-term</td>
                                    <td>
                                    No refund; coin balance is frozen, plan won't renew next year
                                    </td>
                                </tr>

                                <tr>
                                    <td>Turn off auto-renew (monthly or annual)</td>
                                    <td>
                                    Not a cancellation — plan runs till term end, then simply
                                    doesn't renew
                                    </td>
                                </tr>

                                <tr>
                                    <td>Cancel within 7-day free trial</td>
                                    <td>Full refund issued</td>
                                    </tr>

                                <tr>
                                    <td>Don't cancel within 7-day free trial</td>
                                    <td>
                                    Trial converts automatically into the chosen monthly/annual
                                    plan, billed as normal
                                    </td>
                                </tr>

                                <tr>
                                    <td>Switch from monthly to annual mid-cycle</td>
                                    <td>
                                    No refund; monthly plan ends immediately, annual plan starts
                                    same day for a full year; existing coins carry over and annual
                                    coins are added on top
                                    </td>
                                </tr>

                                <tr>
                                    <td>Change of mind after subscribing (no trial, no defect)</td>
                                    <td>Refund not applicable</td>
                                </tr>
                                </tbody>
                            </Table>
                        </div>

                        <h5>4. How to Request a Refund</h5>
                        <p>To request a refund (where eligible), please email us at: <span className="text-warning"><b>support@shaadimaterial.com</b></span></p>
                        <p>Include the following details:  </p>
                        <ul>
                            <li>Registered email address</li>
                            <li>Order or invoice ID</li>
                            <li>Clear reason for the refund request</li>
                            <li>Any relevant supporting information</li>
                        </ul>
                        <p>Submitting a request does not guarantee approval. All requests are reviewed individually.</p>
                        <h5>5. Refund Processing</h5>
                        <p>If a refund is approved:</p>
                        <ul>
                            <li>The amount will be credited to the original payment method</li>
                            <li>Processing may take up to 10 business days, depending on your bank or payment provider</li>
                            <li>Any payment gateway or processing fees are non-refundable</li>
                            <li>Any coins associated with the refunded purchase will be removed from your account balance</li>
                        </ul>
                        <h5>6. No Partial or Pro-Rated Refunds</h5>
                        <p>Approved refunds apply only to the specific charge in question. We do not offer:</p>
                        <ul>
                            <li>Partial refunds</li>
                            <li>Pro-rated refunds for unused time or unused coins</li>
                            <li>Credits for future purchases</li>
                        </ul>
                        <p>Access remains available for the duration of the paid period even after cancellation.</p>
                        <h5> 7. Policy Updates</h5>
                        <p>
                           Shaadi Material reserves the right to update or modify this Refund Policy at any time. Changes will
                            be reflected by updating the &quot;Effective Date&quot; above. Continued use of our services constitutes
                            acceptance of the revised policy.
                        </p>
                        <h5>8. Applicable Laws &amp; Consumer Rights</h5>
                        <p>
                            This policy is intended to comply with applicable consumer protection laws, including those in India.
                            Depending on your jurisdiction, you may have additional statutory rights. Where local laws provide
                            stronger protections, those laws will prevail.
                        </p>
                        <h5>9. Contact</h5>
                        <p>
                            For any questions regarding this Refund Policy, please contact us at: <span className="text-warning"><b>support@shaadimaterial.com</b></span>
                        </p>
                    </Col>
                </Row>
            </Container>
        </>
    );
};

export default Refundpolicy;